import { z } from 'zod';

export const CakeToOrderNonIncludedServiceModelSchema = z.object({
    name: z.string(),
});

export type CakeToOrderNonIncludedServiceModel
    = z.infer<typeof CakeToOrderNonIncludedServiceModelSchema>;
